import dashboardReducer from './dashboard.slice'

export default dashboardReducer
